import Vue from 'vue';
import VueRouter from 'vue-router'
import Meta from 'vue-meta'

import Index from "../../components/Index"
import Login from "../../components/Auth/Login"
import Dashboard from "../../components/Dashboard/Index"
import Orders from "../../components/Dashboard/Orders/Collection"
import Statistics from "../../components/Dashboard/Statistics/Index"
import Searches from "../../components/Dashboard/Searches/Collection"
import Settings from "../../components/Dashboard/Settings/Index"
import Documentation from "../../components/Dashboard/Documentation/Index"
import Earnings from "../../components/Dashboard/Earnings/Index"
import Invoice from "../../components/Dashboard/Earnings/Invoice"

Vue.use(VueRouter)
Vue.use(Meta)

const routes = [
  {
    name: 'index',
    path: '/',
    component: Index,
  },

  {
    name: 'login',
    path: '/login',
    component: Login,
    meta: {
      guest: true
    },
  },

  {
    name: 'dashboard',
    path: '/dashboard',
    component: Dashboard,
    meta: {
      auth: true
    },
    children: [
      {
        name: 'statistics',
        path: 'statistics',
        component: Statistics,
        meta: {
          auth: true
        },
      },
      {
        name: 'searches',
        path: 'searches',
        component: Searches,
        meta: {
          auth: true
        },
      },
      {
        name: 'orders',
        path: 'orders',
        component: Orders,
        meta: {
          auth: true
        },
      },
      {
        name: 'settings',
        path: 'settings',
        component: Settings,
        meta: {
          auth: true
        },
      },
      {
        name: 'documentation',
        path: 'documentation',
        component: Documentation,
        meta: {
          auth: true
        },
      },
      {
        name: 'earnings',
        path: 'earnings',
        component: Earnings,
        meta: {
          auth: true
        },
      },
      {
        name: 'earnings.invoice',
        path: 'earnings/:uuid',
        component: Invoice,
        meta: {
          auth: true
        },
      },
    ]
  },
];

const authFromStore = (store) => {
  return null !== store.state.auth.affiliate.email
}

const authByToken = async (store) => {
  const token = window.$cookies.get('authToken')

  if (token) {
    await store.dispatch('auth/token', {token})

    return authFromStore(store)
  }

  return false
}

export function createRouter (store) {

  let router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
      /**
       * If there is saved position - display it
       */
      if (savedPosition) {
        return savedPosition;

        /**
         * Otherwise check if to-route has custom scroll-saving enabled. If no - scroll to beginning, if yes - do not
         * do anything, and the route will be loaded with the scroll position of previous one
         */
      } else if (to.meta.saveScroll !== true) {
        return {x: 0, y: 0};
      }
    }
  });

  router.beforeEach(async (to, from, next) => {

    if(to.meta.guest === true){
      //todo - remove auth
      return next();
    } else if(to.meta.auth === true){

      if(authFromStore(store) || await authByToken(store)){
        return next();
      }

      return next('/login');
    }

    return next();
  });

  return router;

}



// WEBPACK FOOTER //
// ./resources/assets/js/app/router/index.js